// extracted by mini-css-extract-plugin
export default {"ActionList_Divider":"PullRequestCodeButton-module__ActionList_Divider--RyrUL"};